import {Page} from '../fepp'
import { mountOnId } from 'shared'

document.addEventListener("DOMContentLoaded", () => {
  mountOnId(Page, 'fepp-root')
})
